// extracted by mini-css-extract-plugin
export default {"wrapper":"nyNkO","container":"ma3qE","imageContainer":"T6Z05","image":"Dfgar","discount":"DdKdY","title":"KWCUS","subtitle":"H4PXE"};